import React, { useState, useEffect,useRef } from "react";
import {getAxiosResponse, putAxiosResponse,downloadFile} from "../../../services/authApiRoutes/APImethods";
import APIUrls from "../../../services/APIUrls";
import Constants from "../../../Constants";
import {useParams } from "react-router-dom";
import {ConditionalBlock} from '../../../ConditionalBlock';
import { dateFormat, transformBlankToNull } from "../../../services/Util";
import ChangeOrderCreateForm from "./ChangeOrderCreateForm";
import $ from "jquery";
import Tooltip from "react-tooltip";
import { confirmAlert } from "react-confirm-alert";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { handleError } from "../../../services/authApiRoutes/APImethods";
import { Link } from "react-router-dom";
import { RotatingLines } from "react-loader-spinner";
import DateFormat from "../../../pages/DateFormat";

export default function ChangeOrder(prop) {
  const param = useParams();
  const { t } = useTranslation();
  const translate = t;
  const [showCreateChangeOrder, setShowCreateChangeOrder] = useState(false);
  const [refreshPage, setRefreshPage] = useState(false);
  const [resourceId, setResourceId] = useState("");
  const [project, setProject] = useState({});
  const [changeOrders, setChangeOrders] = useState([]);
  const [co,setChangeOrder] = useState({});
  const [displayLanguages,setDisplayLanguages] = useState([])
  const [rejectDescription,setRejectDescription] = useState("");
  const [coToCancel,setCoToCancel] = useState({});
  const [bidItemId,setBidItemId] = useState([]);
  const [loader,setLoader] = useState(true)
  const [updateChangeOrderError,setUpdateChangeOrderError] = useState('')
  const [noDataAvailaible,setNoDataAVailaible] = useState(false)
  const [internalTranslation, setInternalTranslationRequest] = useState({});
  const changeOrderId = param.tabId;
  const projectDetail = prop.projectDetail.resource.projectResource
  const projectDisplay = prop.projectDetail.displayName[0]
  const owner = useSelector(
    (loginSessionDetail) => loginSessionDetail.loginSession
  ).value
  const removeLangRef = useRef(null);
  function orderShow(id) {
    setLoader(true)
    setChangeOrder({})
    resourceId === id ? setResourceId("") : setResourceId(id);
  }
  const itemTaskDisplay = {
    "translation_translated_words":"Already translated (100%)",
    "translation_repeated_words":"Repetitions",
  }
  const priceBreakDownOptions = [
    "translation_translated_words" ,
    "translation_repeated_words" ,
    "translation_fuzzy_match_words",
    "translation_new_words",
    "translation_75_84_fuzzy_match_words",
    "translation_85_94_fuzzy_match_words",
    "translation_95_99_fuzzy_match_words",
    "in_context_exact",
    "machine_translated"
  ]
  useEffect(()=>{
    if(changeOrderId){
      orderShow(parseInt(changeOrderId));
    }
    if(prop.changeOrderId){
      orderShow(parseInt(prop.changeOrderId));
    }
  },[changeOrderId,prop.changeOrderId]);
  const getChangeOrderForProject = () =>{
    getAxiosResponse(APIUrls.CHANGE_ORDER_BY_PROJECT(param.id))
    .then((res) => {
        if(res.data.data.length === 0){
          setNoDataAVailaible(true)
        }
        setChangeOrders(res.data.data);
    }).catch((err) => {
      console.error(err);
    });
  }
  useEffect(() => {
    getProject(param.id);
    getChangeOrderForProject()
     $('.create-changeBtn').trigger('focus');
  }, [showCreateChangeOrder,refreshPage]);

  useEffect(()=>{
    if(resourceId!==""){
      getAxiosResponse(APIUrls.UPDATE_CHANGE_ORDER(param.id,resourceId))
      .then((response)=>{
         setDisplayLanguages(response.data.data.displayName[0])
         let co = response.data.data.resource;
        if(co.projectAssetsToRemove?.length > 0){
          getAxiosResponse(APIUrls.GET_SOURCE_ASSETS(param.id))
          .then((res) => {
            if (res.data !== "") {
              let source = res.data.data.result;
              let projectAssetsToRemove = [];
              co.projectAssetsToRemove.forEach((pa) => {
                const id = pa.id;
                const filteredAssets = source.filter((so)=>so.id===id);
                if(filteredAssets.length >0){
                  const asset = filteredAssets[0];
                  var fileSize = asset.files.FINAL.documentFile.sizeInKilobytes
                  projectAssetsToRemove.push({name:asset.name,id:asset.id,sizeInKilobytes:fileSize,data:asset});
                }
              });
              co.projectAssetsToRemove = projectAssetsToRemove;
              setChangeOrder(co);
              setLoader(false)
            }
          }).catch(err=>{
            console.error(err)
          })
        }else{
          setChangeOrder(co);
          setLoader(false)
        }
      }).catch(err=>{
        console.error(err)
      })
    }
  },[resourceId]);

  const getProject = (projectId) =>{
    getAxiosResponse(APIUrls.PROJECT(projectId))
    .then((response)=>{
      if(response.data.code ===200){
        const projectData = response.data.data.resource;
        setProject(response.data.data.resource);
        if(projectData.projectResource.projectVendorType ==="INTERNAL"){
          getData(projectId);
        }
      }
    }).catch((err)=>{
      console.error(err);
    });
    $('.create-changeBtn').trigger('focus');
  };

  const getData = (projectId) => {
    getAxiosResponse(APIUrls.INTERNAL_REQUEST(projectId))
      .then((res) => {
        if (res.data !== "") {
          setInternalTranslationRequest(res.data.data);
        }
      })
      .catch((err) => {
        handleError(err);
      });
  };

  const openCancelBox = (changeOrder)=>{
    $(document.activeElement).addClass('rejectFocus');
    setCoToCancel(changeOrder);
    document.body.classList.add("modal-open");
    setTimeout(() => {
      $('#cancelDelete').trigger('focus');
    }, 300);
  };

  const confirmCancelSubmit = () => {
    $("#rejectingNotes").value=''
    $(document.activeElement).addClass('delFocus');
    setTimeout(() => {
     $("#react-confirm-alert").attr({
       'aria-modal': 'true',
       'role': 'dialog',
       'aria-labelledby':"cancelChangeOrder"
       });
       $("h1").attr({
       'id': 'cancelChangeOrder',
      });
     }, 200);
     setTimeout(() => {
       $("#notCancelling").trigger("focus");
     }, 500);
    confirmAlert({
        title: 'Cancel Change Order',
        message: <div className='react-confirmPopup'><p>{translate("change_order.sure")}</p></div>,
        buttons: [
            {
                id:'cancelling',
                label: "Yes",
                onClick: () =>cancelChangeOrder(),
                onKeyDown : (e) => {
                  if(e.key === Constants.TAB){
                    if(e.shiftKey === true){
                    e.preventDefault()
                    $('#notCancelling').trigger('focus');
                    }
                  } else if (e.key === Constants.ESCAPE) {
                    $('.delFocus').trigger("focus");
                    $('.delFocus').removeClass("delFocus");
                  }
                }
            },
            {
                label: 'No',
                id:'notCancelling',
                onClick: () => {
                  $('.delFocus').trigger("focus");
                  $('.delFocus').removeClass("delFocus");
                },
                onKeyDown : (e) => {
                  if(e.key === 'Tab'){
                      e.preventDefault()
                      $('#cancelling').trigger('focus');
                  } else if (e.key === Constants.ESCAPE) {
                    $('.delFocus').trigger("focus");
                    $('.delFocus').removeClass("delFocus");
                  }
                }
            },
        ],
        closeOnEscape: true,
        closeOnClickOutside: true,
        // keyCodeForClose: [8, 32],
        // willUnmount: () => {},
        // afterClose: () => {},
        // onClickOutside: () => {},
        // onKeypress: () => {},
        // onKeypressEscape: () => {},
        overlayClassName: "delete_overlay",
    });
  };
  const getConfirmMsg = () =>{
    var projectVendorType = prop.projectDetail.resource.projectResource.projectVendorType
    if(projectVendorType === 'INTERNAL'){
      return Constants.CHANGE_ORDER_INTERNAL_TRANSLATOR_ACCEPT
    }else{
      return Constants.CHANGE_ORDER_CUSTOMER_ACCEPT
    }
      
  }
  const confirmAcceptCo = () => {
    $(document.activeElement).addClass('delFocus');
    setTimeout(() => {
     $("#react-confirm-alert").attr({
       'aria-modal': 'true',
       'role': 'dialog',
       'aria-labelledby':"acceptChangeOrder"
       });
       $("h1").attr({
       'id': 'acceptChangeOrder',
      });
     }, 200);
     setTimeout(() => {
       $("#notAccepting").trigger("focus");
     }, 500);
    confirmAlert({
        title: 'Accept Change Order',
        message: <div className='react-confirmPopup'><p>{getConfirmMsg()}</p></div>,
        buttons: [
            {
                id:'accepting',
                label: "Yes",
                onClick: () =>acceptChangeOrder(),
                onKeyDown : (e) => {
                  if(e.key === Constants.TAB){
                    if(e.shiftKey === true){
                    e.preventDefault()
                    $('#notAccepting').trigger('focus');
                    }
                  } else if (e.key === Constants.ESCAPE) {
                    $('.delFocus').trigger("focus");
                    $('.delFocus').removeClass("delFocus");
                  }
                }
            },
            {
                id:'notAccepting',
                label: "No",
                onClick: () => {
                  $('.delFocus').trigger("focus");
                  $('.delFocus').removeClass("delFocus");
                },
                onKeyDown : (e) => {
                  if(e.key === 'Tab'){
                      e.preventDefault()
                      $('#accepting').trigger('focus');
                  } else if (e.key === Constants.ESCAPE) {
                    $('.delFocus').trigger("focus");
                    $('.delFocus').removeClass("delFocus");
                  }
                }
            },
        ],
        closeOnEscape: true,
        closeOnClickOutside: true,
        // keyCodeForClose: [8, 32],
        // willUnmount: () => {},
        // afterClose: () => {},
        // onClickOutside: () => {},
        // onKeypress: () => {},
        // onKeypressEscape: () => {},
        overlayClassName: "delete_overlay",
    });
  };
  const showUpdateError = () =>{
    confirmAlert({
      title: 'Apologies from OPAL-Marketing',
      message: <div className='react-confirmPopup'><p>You do not have access to accept change request</p>
      <p>{updateChangeOrderError}</p>
      </div>,
      buttons: [
          {
              label: "Close",
              onClick: () => {
                setUpdateChangeOrderError('')
              },
              
          },
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
      overlayClassName: "delete_overlay",
  });
  }
  const acceptChangeOrder = ()=>{
    let changeOrder = co;
    changeOrder.status = "customer_accepted";
    updateChangeOrder(param.id,changeOrder);
  }
  const cancelChangeOrder = ()=>{
    let co = coToCancel;
    co.rejectionDescription = rejectDescription;
    //co.status = {code: "cancelled",display:"Canceled",originalEnum:"CANCELED"};
    co.status = "cancelled";
    updateChangeOrder(param.id,co);
  };

  const updateChangeOrder = (id,payload)=>{
    const formData = transformBlankToNull(payload);
    putAxiosResponse(APIUrls.UPDATE_CHANGE_ORDER(id,payload.id),formData)
        .then((res) => {
          if(res.data.error){
            setUpdateChangeOrderError(res.data.error)
            showUpdateError()
          }else{
            hideEditModal();
            setRejectDescription("");
            setRefreshPage(refreshPage?false:true);
            $(".lastdisable").trigger("focus");
          }
            
        }).catch((err) => {
            console.error(err);
        });
  };
  const downloadAddedFile = (data,co,type) =>{
    if(type === 'added'){
      var fileId = data.fileId
      var changeOrderId = co.id
      var projectId = param.id
      downloadFile(APIUrls.DOWNLOAD_CHANGEORDER_DOCUMENT(fileId,changeOrderId,projectId),data.filename)
        .then((res) => {
        })
        .catch((err) => {
          handleError(err);
        });
    }else{
       fileId = data.files.FINAL.documentFile.fileId
      downloadFile(APIUrls.DOWNLOAD_FILE(fileId,"PROJECT",param.id),data.name)
        .then((res) => {
        })
        .catch((err) => {
          handleError(err);
        });
    }
    
  }
  const hideEditModal = () => {
    makeEditDisable();
    document.body.classList.remove("modal-open");
    $('.rejectFocus').trigger("focus");
    $('.rejectFocus').removeClass("rejectFocus");
  };

  const handleCancel = (event) => {
    event.preventDefault(); 
    setRejectDescription("");
    hideEditModal();
  };

  const makeEditDisable = () => {
    const editButton = $("#reject-change-order");
    if (!editButton.hasClass("disabled-btn")) {
      editButton.addClass("disabled-btn");
      editButton.removeClass("active");
    }
  };

  const GetChangeOrder = (prop)=>{
    return (
      <>
        <ul>
          <li>
            <div className="title">Status</div>
            <div className="text">
            {co.status !== undefined && co.status.originalEnum !== undefined ? translate("change_order_status."+co?.status?.originalEnum):""}
            </div>
          </li>
          <li>
            <div className="title">Dates</div>
            <div className="text">
            <div className='relative'>
              <div className='font-zero setFastpass'>
                  <ConditionalBlock condition={co.eventDates?.created}>
                      <span>
                        Created: {" "} <DateFormat date={co?.eventDates?.created}/>
                      </span>{" "}
                  </ConditionalBlock>
                  <ConditionalBlock condition={co?.eventDates?.rejectedByVendor}>
                      <span>
                        Vendor Rejected: {" "} <DateFormat date={co?.eventDates?.rejectedByVendor}/>
                      </span>{" "}
                  </ConditionalBlock>
                  <ConditionalBlock condition={co?.eventDates?.rejectedByCustomer}>
                      <span>
                        Quote Rejected: {" "} <DateFormat date={co?.eventDates?.rejectedByCustomer}/>
                      </span>{" "}
                  </ConditionalBlock>

                  <ConditionalBlock condition={co?.eventDates?.acceptedByVendor}>
                      <span>
                      Vendor Accepted: {" "} <DateFormat date={co?.eventDates?.acceptedByVendor}/>
                      </span>{" "}
                  </ConditionalBlock>

                  <ConditionalBlock condition={co?.eventDates?.bidSubmittedToCustomer}>
                      <span>
                      Quote Submitted: {" "} <DateFormat date={co?.eventDates?.bidSubmittedToCustomer}/>
                      </span>{" "}
                  </ConditionalBlock>

                  <ConditionalBlock condition={co?.eventDates?.acceptedByCustomer}>
                      <span>
                      Quote Accepted: {" "} <DateFormat date={co?.eventDates?.acceptedByCustomer}/>
                      </span>{" "}
                  </ConditionalBlock>
              </div>

              <ConditionalBlock condition={co.eventDates?.created}>
                  <p aria-hidden="true">
                      <span>
                        Created: {" "} <DateFormat date={co?.eventDates?.created}/>
                      </span>
                  </p>{" "}
              </ConditionalBlock>
              <ConditionalBlock condition={co?.eventDates?.rejectedByVendor}>
                  <p aria-hidden="true">
                      <span>
                        Vendor Rejected: {" "} <DateFormat date={co?.eventDates?.rejectedByVendor}/>
                      </span>
                  </p>{" "}
              </ConditionalBlock>
              <ConditionalBlock condition={co?.eventDates?.rejectedByCustomer}>
                  <p aria-hidden="true">
                      <span>
                      Quote Rejected: {" "} <DateFormat date={co?.eventDates?.rejectedByCustomer}/>
                      </span>
                  </p>{" "}
              </ConditionalBlock>

              <ConditionalBlock condition={co?.eventDates?.acceptedByVendor}>
                  <p aria-hidden="true">
                      <span>
                        Vendor Accepted: {" "} <DateFormat date={co?.eventDates?.acceptedByVendor}/>
                      </span>
                  </p>{" "}
              </ConditionalBlock>

              <ConditionalBlock condition={co?.eventDates?.bidSubmittedToCustomer}>
                  <p aria-hidden="true">
                      <span>
                      Quote Submitted: {" "} <DateFormat date={co?.eventDates?.bidSubmittedToCustomer}/>
                      </span>
                  </p>{" "}
              </ConditionalBlock>

              <ConditionalBlock condition={co?.eventDates?.acceptedByCustomer}>
                  <p aria-hidden="true">
                      <span>
                      Quote Accepted: {" "} <DateFormat date={co?.eventDates?.acceptedByCustomer}/>
                      </span>
                  </p>{" "}
              </ConditionalBlock>
            </div>
            </div>
            </li>
            {co?.languagesToRemove?.length > 0 ? (
              <li>
                <div className="title">
                  Removed Project Lang.
                </div>
                <div className="text wrap-remove-lang">
                  {co?.languagesToRemove?.map((langAdd, index) => {
                    return (
                      <p className="changeOrderLanguages pr-9" key={index} >
                        {langAdd}
                      </p>
                      );
                    }
                  )}
                </div>
              </li>) : null}
              {co?.languagesToAdd?.length>0 ? (
                <li>
                  <div className="title">Added Project Lang.</div>
                  <div className="text">
                    {displayLanguages?.map((langAdd, index) => {
                      return (
                        <p className="changeOrderLanguages" key={index} >
                          {langAdd.display}
                        </p>);}
                    )}
                  </div>
                </li>) : null}
                {co?.rejectionDescription !== '' ? (
                <li>
                  <div className="title">Explanation for cancelation</div>
                  <div className="text">
                          {co?.rejectionDescription}
                  </div>
                </li>) : null}
                {co?.autoAccept ? (
                <li>
                  <div className="title">Change Order Quote</div>
                  <div className="text">
                  {`Yes - automatically approve the Quote submitted by ${projectDetail?.vendor?.name}`} 
                  </div>
                </li>) : null}
              {co?.changeOrderDocument?.length> 0 ? (
                <li>
                  <div className="title">Source Files Added</div>
                  <div className="text" style={{display: "flex",justifyContent: "flex-start",width: "1200px",flexWrap: "wrap"}}>
                    {co?.changeOrderDocument?.map((cod,idx)=>{
                      return (
                        <>
                          <p className="changeOrderLanguages" key={idx}>
                            <Link onClick={(e)=>{e.preventDefault(e); downloadAddedFile(cod,co,'added')}}>{cod.filename}</Link>
                            <button
                              aria-label="tooltip"
                              className="pl-10"
                              data-tip
                              data-place="right"
                              data-for={`file-${idx}`}
                            >
                              <svg
                                style={{marginBottom:"-3px"}}
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                              >
                                <path
                                  d="M8 15C6.14348 15 4.36301 14.2625 3.05025 12.9497C1.7375 11.637 1 9.85652 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8C15 9.85652 14.2625 11.637 12.9497 12.9497C11.637 14.2625 9.85652 15 8 15ZM8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16Z"
                                  fill="#64748B"
                                ></path>
                                <path
                                  d="M8.92995 6.588L6.63995 6.875L6.55795 7.255L7.00795 7.338C7.30195 7.408 7.35995 7.514 7.29595 7.807L6.55795 11.275C6.36395 12.172 6.66295 12.594 7.36595 12.594C7.91095 12.594 8.54395 12.342 8.83095 11.996L8.91895 11.58C8.71895 11.756 8.42695 11.826 8.23295 11.826C7.95795 11.826 7.85795 11.633 7.92895 11.293L8.92995 6.588ZM8.99995 4.5C8.99995 4.76522 8.8946 5.01957 8.70706 5.20711C8.51952 5.39464 8.26517 5.5 7.99995 5.5C7.73474 5.5 7.48038 5.39464 7.29285 5.20711C7.10531 5.01957 6.99995 4.76522 6.99995 4.5C6.99995 4.23478 7.10531 3.98043 7.29285 3.79289C7.48038 3.60536 7.73474 3.5 7.99995 3.5C8.26517 3.5 8.51952 3.60536 8.70706 3.79289C8.8946 3.98043 8.99995 4.23478 8.99995 4.5Z"
                                  fill="#64748B"
                                ></path>
                              </svg>
                            </button>
                            <Tooltip
                              className="extraClass"
                              id={`file-${idx}`}
                              delayHide={500}
                              effect="solid"
                            >
                              <div className="react-innerTooltip">
                              {cod.sizeInKilobytes} KB
                              </div>
                            </Tooltip>
                          </p>{" "}
                        </>)})}
                  </div>
                </li>) : null}
                {co?.projectAssetsToRemove?.length>0 ?(
                  <li>
                    <div className="title">Source Files Removed</div>
                    <div className="text">
                    {co?.projectAssetsToRemove.map((pa,idx)=>{
                      return (
                          <p className="changeOrderLanguages" key={idx}>
                          <Link onClick={(e)=>{e.preventDefault(e); downloadAddedFile(pa.data,co,'removed')}}>{pa.name}</Link>
                          <button
                              aria-label="tooltip"
                              className="pl-10"
                              data-tip
                              data-place="right"
                              data-for={`file-removed-${idx}`}
                            >
                              <svg
                               style={{marginBottom:"-3px"}}
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                              >
                                <path
                                  d="M8 15C6.14348 15 4.36301 14.2625 3.05025 12.9497C1.7375 11.637 1 9.85652 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8C15 9.85652 14.2625 11.637 12.9497 12.9497C11.637 14.2625 9.85652 15 8 15ZM8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16Z"
                                  fill="#64748B"
                                ></path>
                                <path
                                  d="M8.92995 6.588L6.63995 6.875L6.55795 7.255L7.00795 7.338C7.30195 7.408 7.35995 7.514 7.29595 7.807L6.55795 11.275C6.36395 12.172 6.66295 12.594 7.36595 12.594C7.91095 12.594 8.54395 12.342 8.83095 11.996L8.91895 11.58C8.71895 11.756 8.42695 11.826 8.23295 11.826C7.95795 11.826 7.85795 11.633 7.92895 11.293L8.92995 6.588ZM8.99995 4.5C8.99995 4.76522 8.8946 5.01957 8.70706 5.20711C8.51952 5.39464 8.26517 5.5 7.99995 5.5C7.73474 5.5 7.48038 5.39464 7.29285 5.20711C7.10531 5.01957 6.99995 4.76522 6.99995 4.5C6.99995 4.23478 7.10531 3.98043 7.29285 3.79289C7.48038 3.60536 7.73474 3.5 7.99995 3.5C8.26517 3.5 8.51952 3.60536 8.70706 3.79289C8.8946 3.98043 8.99995 4.23478 8.99995 4.5Z"
                                  fill="#64748B"
                                ></path>
                              </svg>
                            </button>
                            <Tooltip
                              className="extraClass"
                              id={`file-removed-${idx}`}
                              delayHide={500}
                              effect="solid"
                            >
                              <div className="react-innerTooltip">
                              {pa.sizeInKilobytes} KB
                              </div>
                            </Tooltip>
                          </p>
                      )
                    })}
                    </div>
                  </li>):Constants.BLANK}
                  {co?.description !== '' ? 
                  <li>
                    <div className="title">Notes</div>
                    <div className="text textWrap">{co?.description}
                    </div>
                  </li>:Constants.BLANK}  
                 {(co?.status?.originalEnum ==="VENDOR_BID" || co?.status?.originalEnum ==="CUSTOMER_ACCEPTED") && projectDetail.projectVendorType !== "EXTERNAL_BIDLESS" ?  <li>
                    <div className="title"><h4>Review Change Order Quote</h4></div>
                  </li>:Constants.BLANK
                 }
                  <ConditionalBlock condition={co.originalBid !== ''}>
                  {co?.status?.originalEnum ==="VENDOR_BID" ? <GetBidOptions bid={co?.originalBid} name={"Original Quote"} showDescription={false}/>:Constants.BLANK}
                  </ConditionalBlock>
                  <ConditionalBlock condition={co.changeOrderBid !== ''}>
                  {(co?.status?.originalEnum ==="VENDOR_BID" || co?.status?.originalEnum ==="CUSTOMER_ACCEPTED") ? <GetBidOptions bid={co?.changeOrderBid} name={"Updated Quote"} showDescription={true}/>:Constants.BLANK}
                  </ConditionalBlock>

                  {showAcceptButton() ?
                  <li>
                    <div className="flex justify-end btn-gap w-d100 mr-15">
                      <button className="blue-btn" onClick={()=>openCancelBox(co)}>Cancel Change Order</button>
                      <button className="blue-btn active" onClick={confirmAcceptCo}>Accept</button>
                    </div>
                  </li>:Constants.BLANK}
        </ul>
      </>);
  };
  const showAcceptButton = ()=>{
    if(project?.projectResource?.projectVendorType ==="INTERNAL"){
      if(co?.status?.originalEnum === "REQUESTED" && internalTranslation?.assigneeUser?.userId === owner?.id){
        return true;
      }
    }else if(co?.status?.originalEnum === "VENDOR_BID"){
      return true;
    }
    return false;
  }
  function SubbreakdownShow(id) {
    var copyBidItemId = [...bidItemId]
    if(bidItemId.includes(id)){
      var index = bidItemId.indexOf(id)
      if (index !== -1) {
        copyBidItemId.splice(index, 1);
        setBidItemId(copyBidItemId)
      }
    }else{
      copyBidItemId.push(id)
      setBidItemId(copyBidItemId)
    }
  }

  const calculateDiscount = (bid)=>{
    if(bid){
      const discountPercentage = bid?.bidDiscount.amount;
      const totalCost = bid?.preDiscountBidCost.value;
      const value = (discountPercentage*totalCost)/100;
      return `$${value.toFixed(2)}`
    }
    return Constants.BLANK;
  }
const tooltipHandle = (event) => {
  if (event.key === Constants.ESCAPE) {
    $(event.target).find('.wrap-tooltip-content').css('display', 'none');
  } else if (event.key === Constants.TAB) {
    $(event.target).find('.wrap-tooltip-content').css('display', '');
  }
}
  const GetBidOptions = (prop)=>{
    const bid = prop.bid;
    const name = prop.name;
    const showDescription = prop.showDescription;
    return (
      <>
        <li>
            <div className="title">{name}</div>
        </li>
        <li>
        <div className="order-table relative">
        <table aria-label={name}>
          <thead>
            <tr>
              <th style={{textAlign:"left"}}>Language</th>
              {bid !== ''  &&
              bid?.bidItems[0]?.bidItemTasks && 
              bid?.bidItems[0]?.bidItemTasks?.length > 0 &&  
              bid?.bidItems[0]?.bidItemTasks?.map(
                (itemTask, index) => {
                  if (itemTask.projectTaskType.parentType === "" ) {
                    return (
                      <th key={index} style={{textAlign:"left"}}>
                        {itemTask.projectTaskType.display}
                      </th>
                    );
                  }
                }
              )}
              <th>Subtotal</th>
            </tr>
          </thead>
          <tbody>
          {bid !== '' && bid?.bidItems.map((item, index) => {
            return (
              <React.Fragment key={index}>
                <tr>
                  <td>
                    <strong>{item.language} {item.languageBeingRemoved ? 
                    <React.Fragment>
                    <button
                      aria-label="tooltip"
                      className="p-5 0 error"
                      data-tip
                      data-place="right"

                      data-for="style-guide-content-0"
                    >
                     {'(Removed)'}
                    </button>
                    
                    <Tooltip
                      className="extraClass"
                      id="style-guide-content-0"
                      delayHide={500}

                      effect="solid"
                    >
                      <div className="react-innerTooltip">
                        
                          <ul>
                            <li className="textWrap">
                              Vendors might charge for work already done for languages being canceled.
                            </li>
                            
                          </ul>
                        
                      </div>
                    </Tooltip>
                   
                  </React.Fragment>
    :''}</strong>
                  </td>
                  {item.bidItemTasks.map(
                    (itemTask, index) => {
                      if (itemTask.projectTaskType.type === "translation") {
                        return (
                          <td key={index}>
                            <button className={bidItemId.includes(item.id) ? "breakdown flex-center inner show-main" : "breakdown flex-center inner"}
                              id={"sub-breakdown-"+item.id}
                              onClick={() => SubbreakdownShow(item.id)} aria-expanded={bidItemId.includes(item.id) ? "true" : "false"} aria-label={itemTask.cost.display + " details"}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" >
                                <path d="M12.8245 7.79075L10.0011 10.6141L7.17781 7.79075L5.87614 9.08325L10.0011 13.2083L14.1261 9.08325L12.8245 7.79075ZM10.0011 0.833252C4.94114 0.833252 0.834473 4.93992 0.834473 9.99992C0.834473 15.0599 4.94114 19.1666 10.0011 19.1666C15.0611 19.1666 19.1678 15.0599 19.1678 9.99992C19.1678 4.93992 15.0611 0.833252 10.0011 0.833252ZM10.0011 17.3333C5.94947 17.3333 2.66781 14.0516 2.66781 9.99992C2.66781 5.94825 5.94947 2.66659 10.0011 2.66659C14.0528 2.66659 17.3345 5.94825 17.3345 9.99992C17.3345 14.0516 14.0528 17.3333 10.0011 17.3333Z"
                                  fill="#1D4ED8"  ></path>
                              </svg>
                              <span className="blue pl-5">
                                {itemTask.cost.display}
                              </span>
                            </button>
                          </td>
                        );
                      } else if (itemTask.projectTaskType.parentType === "" 
                      ) {
                        return (
                          <td key={index}>
                            {itemTask.cost.displayWithDecimals}
                          </td>
                        );
                      }
                    }
                  )}
                  <td>
                    <strong>
                      {item.totalBidItemCost.displayWithDecimals}
                    </strong>
                  </td>
                </tr>
                <tr aria-hidden={bidItemId.includes(item.id) ? 'false' : 'true'}>
                  <td colSpan="4" className="p-0">
                    <div className={bidItemId.includes(item.id) ? "translation-sub-list show-details" : "translation-sub-list"} id="sub-breakdown-details" >
                      <div className="head">
                        {item.language} Translation Memory Leveraging Information
                      </div>
                      <div className="list-heading co-bid-flex">
                        <div></div>
                        <div>Number of words</div>
                        <div>
                          Cost per word
                          <div className="gb-tooltip" tabIndex="0" onKeyDown={(e)=>tooltipHandle(e)}>
                            <button aria-label="tooltip" tabIndex="-1">
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" >
                                <path d="M8 15C6.14348 15 4.36301 14.2625 3.05025 12.9497C1.7375 11.637 1 9.85652 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8C15 9.85652 14.2625 11.637 12.9497 12.9497C11.637 14.2625 9.85652 15 8 15ZM8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16Z"
                                  fill="#64748B" ></path>
                                <path d="M8.92995 6.588L6.63995 6.875L6.55795 7.255L7.00795 7.338C7.30195 7.408 7.35995 7.514 7.29595 7.807L6.55795 11.275C6.36395 12.172 6.66295 12.594 7.36595 12.594C7.91095 12.594 8.54395 12.342 8.83095 11.996L8.91895 11.58C8.71895 11.756 8.42695 11.826 8.23295 11.826C7.95795 11.826 7.85795 11.633 7.92895 11.293L8.92995 6.588ZM8.99995 4.5C8.99995 4.76522 8.8946 5.01957 8.70706 5.20711C8.51952 5.39464 8.26517 5.5 7.99995 5.5C7.73474 5.5 7.48038 5.39464 7.29285 5.20711C7.10531 5.01957 6.99995 4.76522 6.99995 4.5C6.99995 4.23478 7.10531 3.98043 7.29285 3.79289C7.48038 3.60536 7.73474 3.5 7.99995 3.5C8.26517 3.5 8.51952 3.60536 8.70706 3.79289C8.8946 3.98043 8.99995 4.23478 8.99995 4.5Z"
                                  fill="#64748B" ></path>
                              </svg>
                            </button>
                            <div className="wrap-tooltip-content">
                              <div className="triangle"></div>
                              <div className="gb-tooltip-content" style={{width:"500px"}}>
                                <p className="textWrap">
                                The cost per word is automatically calculated by OPAL-Marketing based on the number of words and total cost provided by the vendor. There might be slight differences in the cost per word and the total cost based on the number of decimal places used in the calculation.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div >Total Cost</div>
                      </div>
                      {item.bidItemTasks.map(
                        (itemTask, index) => {
                          if (priceBreakDownOptions.includes(itemTask.projectTaskType.type)) {
                            return (
                              <div className="list-content co-bid-flex" key={index} >
                                <div>
                                {itemTaskDisplay[itemTask.projectTaskType.type] ? itemTaskDisplay[itemTask.projectTaskType.type] : itemTask.projectTaskType.display}
                                </div>
                                <div>
                                  {itemTask.numWords}
                                </div>
                                <div>
                                  {itemTask.costPerWord.displayWithDecimals}
                                </div>
                                <div>
                                  {itemTask.cost.displayWithDecimals}
                                </div>
                              </div>
                            );
                          }
                        }
                      )}
                      <div className="list-content list-footer">
                        <div>Total</div>
                        <div>
                          {item.tmLeveragingSummary.totalWords}
                        </div>
                        <div></div>
                        <div>
                          {item.tmLeveragingSummary.totalCost.displayWithDecimals}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td colSpan="2" className="p-0"></td>
                </tr>
              </React.Fragment>
            );
          })}
            <tr>
              <td>Subtotal</td>
              {bid !== '' && bid?.bidTaskSubtotals.map(
                (subTotal, index) => {
                  if (subTotal.taskType.type === "translation") {
                    return (
                      <td className="pl-15" key={index}>
                        {subTotal.subtotal.displayWithDecimals}
                      </td>
                    );
                  }
                  if (subTotal.taskType.parentType ==="") { 
                    return (
                      <td key={index} className="empty">
                        { subTotal.taskType.type !== 'commission' ? subTotal.subtotal.displayWithDecimals : ''}
                      </td>
                    );
                  }
                }
              )}

            </tr>
            <tr>
              <td colSpan="8">
                <div className="footer-first flex-center flex">
                  <p className="italic">
                    All prices are in {projectDisplay.currency.code} ({projectDisplay.currency.pluralLabel})
                  </p>
                  <p className="total">
                    Quote total:{" "}
                    <strong>
                      {bid?.preDiscountBidCost?.display}
                    </strong>
                  </p>
                </div>
              </td>
            </tr>
            {bid?.bidDiscount?.amount > 0 ?   
            <tr>
              <td colSpan="8">
                <div className="footer-first flex-center flex">
                  <p className="italic"></p>
                  <p className="total">
                    Discount ({bid?.bidDiscount?.amount}%) :{" "}
                    <strong>
                      {calculateDiscount(bid)}
                    </strong>
                  </p>
                </div>
              </td>
            </tr> : ''}
            {bid?.bidDiscount?.amount > 0 ?
            <tr>
              <td colSpan="8">
                <div className="footer-first flex-center flex">
                  <p className="italic">
                    
                  </p>
                  <p className="total">
                  {name} Total:{" "}
                    <strong>
                      {bid?.totalBidCost?.display}
                    </strong>
                  </p>
                </div>
              </td>
            </tr> : ''}
          </tbody>
        </table>
        </div>
        </li>
        {showDescription ?
        <li>
            <div className="title">Quote Description</div>
            <div className="text textWrap">
              {bid?.description}
            </div>
        </li>:Constants.BLANK}
      </>
    );
  };

  const ShowChangeOrderButton = ()=>{
    const coList = changeOrders;
    if(project.allowedToCreateChangeOrder){
      return (
        <>
          <button className="btn create-changeBtn" onClick={() => setShowCreateChangeOrder(true)} >
          {translate("change_order.create_co")}            </button>
        </>
      );
    }else if(coList && coList?.length > 0 &&  coList?.filter((co)=> co?.resource?.status?.originalEnum === 'VENDOR_BID')?.length > 0){
      // return (
      //   <>
      //     <button className="btn" onClick={() => setShowCreateChangeOrder(true)} >
      //       Review Pending Change Order
      //     </button>
      //   </>
      // );
    }else if(coList && coList?.length > 0 &&  coList?.filter((co)=> (co?.resource?.status?.originalEnum === 'REQUESTED' || co?.resource?.status?.originalEnum === 'VENDOR_ACCEPTED'))?.length>0){
      // return (
      //   <>
      //     <button className="btn" onClick={() => setShowCreateChangeOrder(true)} >
      //       Review Pending Change Order
      //     </button>
      //   </>
      // );
    }
  };
  const rejectOrderKeydown = (event) => {
    if ($('#cancelDelete').is(':focus') &&
    $('#reject-change-order').hasClass('disabled-btn') &&
    event.key === Constants.TAB && !event.shiftKey) {
      event.preventDefault();
      $('#rejectingNotes').trigger('focus');
    } else if ($('#reject-change-order').is(':focus') && event.key === Constants.TAB && !event.shiftKey) {
      event.preventDefault();
      $('#rejectingNotes').trigger('focus');
    } else if ( $('#reject-change-order').hasClass('disabled-btn') &&
    $('#rejectingNotes').is(':focus') &&
    event.key === Constants.TAB && event.shiftKey) {
      event.preventDefault();
      $('#cancelDelete').trigger('focus');
    } else if ($('#rejectingNotes').is(':focus') && event.key === Constants.TAB && event.shiftKey) {
      event.preventDefault();
      $('#reject-change-order').trigger('focus');
    } else if (event.key === Constants.ESCAPE) {
      handleCancel(event);
    }
  }

  return (
    <div className="listing-content relative">
      {showCreateChangeOrder ? 
        <ChangeOrderCreateForm showCOList={setShowCreateChangeOrder}  funct={prop.funct}
        projectDetail={prop.projectDetail} refreshChangeOrderList={getChangeOrderForProject}/> 
        :(
        <div className="campaign_details-task campaign-form">
          <div className="projects-heading">
            <h5>{translate("change_order.what_change_order")}</h5>
            <ShowChangeOrderButton/>
          </div>
          <div>
            <p>
             {translate("change_order.definition_change_order")}
            </p>
          </div>
          <div className="projects-content">
            <div className="order-table relative">
              {changeOrders &&  changeOrders?.length !== 0 ? (
                <table className="sortable" aria-label="Change Order">
                  <thead>
                    <tr>
                      <th className="no-sort">Name</th>
                      <th className="no-sort">Created On</th>
                      <th className="no-sort">Status</th>
                      <th></th>
                    </tr>
                  </thead>
                  {changeOrders?.map((order, index) => {
                    return (
                      <tbody key={index} className={resourceId === order.resource.id? "show-main-border": ""}>
                        <tr>
                          <td>
                            <div className="order-details">
                              <button className={resourceId === order.resource.id? "flex-center order-inner show-main": "flex-center order-inner"}
                                id={"order-btn-"+index} onClick={() => orderShow(order.resource.id)}
                                tabIndex="0" aria-expanded={resourceId === order.resource.id ? "true" : "false"} aria-label={order.resource.name}>
                                {order?.resource?.name}
                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none" >
                                  <path d="M1 1L5 5L9 1" stroke="#1D4ED8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                              </button>
                            </div>
                          </td>
                          <td>
                          <div className='relative'>
                            <span className='font-zero setFastpass'>
                                <DateFormat date={order.resource.createdDate} />
                            </span>
                            <span aria-hidden="true">
                                <DateFormat date={order.resource.createdDate} />
                            </span>
                          </div>
                          </td>
                          <td>
                          {order.resource.status.originalEnum !== undefined ?
                            <span className="progress progress-orange">
                              { translate("change_order_status."+order.resource.status.originalEnum) }
                            </span>
                            : ''}
                          </td>
                          <td>
                          {(order.resource.status.originalEnum === 'REQUESTED' || order.resource.status.originalEnum === 'VENDOR_ACCEPTED'  || order.resource.status.originalEnum === 'VENDOR_IN_CREATION' || order.resource.status.originalEnum === 'PREPARING_TM') && !showAcceptButton() ?
                            (
                              <button aria-label="cancel change order" className="delete-icon" onClick={()=>openCancelBox(order.resource)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none" >
                                <path d="M8.20039 3.80078H11.8004C11.8004 3.32339 11.6107 2.86555 11.2732 2.52799C10.9356 2.19042 10.4778 2.00078 10.0004 2.00078C9.523 2.00078 9.06516 2.19042 8.7276 2.52799C8.39003 2.86555 8.20039 3.32339 8.20039 3.80078ZM7.00039 3.80078C7.00039 3.00513 7.31646 2.24207 7.87907 1.67946C8.44168 1.11685 9.20474 0.800781 10.0004 0.800781C10.796 0.800781 11.5591 1.11685 12.1217 1.67946C12.6843 2.24207 13.0004 3.00513 13.0004 3.80078H19.0004C19.1595 3.80078 19.3121 3.864 19.4247 3.97652C19.5372 4.08904 19.6004 4.24165 19.6004 4.40078C19.6004 4.55991 19.5372 4.71252 19.4247 4.82505C19.3121 4.93757 19.1595 5.00078 19.0004 5.00078H17.7356L16.3028 17.4136C16.2015 18.291 15.7812 19.1006 15.1218 19.6883C14.4625 20.2759 13.61 20.6007 12.7268 20.6008H7.27399C6.39074 20.6007 5.53833 20.2759 4.87895 19.6883C4.21958 19.1006 3.79927 18.291 3.69799 17.4136L2.26519 5.00078H1.00039C0.841261 5.00078 0.688648 4.93757 0.576127 4.82505C0.463605 4.71252 0.400391 4.55991 0.400391 4.40078C0.400391 4.24165 0.463605 4.08904 0.576127 3.97652C0.688648 3.864 0.841261 3.80078 1.00039 3.80078H7.00039ZM4.88959 17.2768C4.9573 17.8617 5.23765 18.4012 5.67729 18.7929C6.11694 19.1845 6.68521 19.4009 7.27399 19.4008H12.7268C13.3156 19.4009 13.8838 19.1845 14.3235 18.7929C14.7631 18.4012 15.0435 17.8617 15.1112 17.2768L16.5272 5.00078H3.47359L4.88959 17.2768ZM8.20039 8.00078C8.35952 8.00078 8.51213 8.06399 8.62466 8.17652C8.73718 8.28904 8.80039 8.44165 8.80039 8.60078V15.8008C8.80039 15.9599 8.73718 16.1125 8.62466 16.225C8.51213 16.3376 8.35952 16.4008 8.20039 16.4008C8.04126 16.4008 7.88865 16.3376 7.77613 16.225C7.6636 16.1125 7.60039 15.9599 7.60039 15.8008V8.60078C7.60039 8.44165 7.6636 8.28904 7.77613 8.17652C7.88865 8.06399 8.04126 8.00078 8.20039 8.00078ZM12.4004 8.60078C12.4004 8.44165 12.3372 8.28904 12.2247 8.17652C12.1121 8.06399 11.9595 8.00078 11.8004 8.00078C11.6413 8.00078 11.4886 8.06399 11.3761 8.17652C11.2636 8.28904 11.2004 8.44165 11.2004 8.60078V15.8008C11.2004 15.9599 11.2636 16.1125 11.3761 16.225C11.4886 16.3376 11.6413 16.4008 11.8004 16.4008C11.9595 16.4008 12.1121 16.3376 12.2247 16.225C12.3372 16.1125 12.4004 15.9599 12.4004 15.8008V8.60078Z" fill="#6D7080" ></path>
                                </svg>
                              </button>)
                            :Constants.BLANK
                          }
                          </td>
                        </tr>
                        <tr aria-hidden={resourceId === order.resource.id ? 'false' : 'true'}>
                          <td colSpan="4" className="p-0">
                            <div className={resourceId === order.resource.id ? "order-details-inner show-details" : "order-details-inner" } id="order-details-inner" >
                              {
                                loader ? 
                                <div className="gb-loader">
                                  <RotatingLines
                                  strokeColor="#0096FF"
                                  strokeWidth="5"
                                  width="80"
                                  visible={true}
                                  />
                                </div>
                                 :
                                <GetChangeOrder coId={resourceId} key={index}/>
                                              }
                              
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    );
                  })}
                </table>
              ) :
              noDataAvailaible ?  
              (
                <div className="no-data-display align-center">
                  <i className="nodata-icon"></i>
                  <p>{Constants.NO_CHANGE_ORDER}</p>
                </div>
              ):
              <div className="gb-loader">
                <RotatingLines
                  strokeColor="#0096FF"
                  strokeWidth="5"
                  width="100"
                  visible={true}
                />
              </div>
            }
            </div>
          </div>
          <div className='lightbox-panel' aria-labelledby="rejectOrder" aria-modal="true" role="dialog"
          onKeyDown={(e)=>rejectOrderKeydown(e)}
          >
            <div className="inner-lightbox-panel purchase-order-popup pb-0">
              <div className="modal-header flex padd-lr">
                <h5 id="rejectOrder">{translate("change_order.provide_cancel_reason")}</h5>
              </div>
              <div className="lightbox-content padd-22">
                    <div className="global-dropdown-block mar-bot6 w-d100">
                        <textarea id="rejectingNotes" value={rejectDescription} className="textarea" title="Description / Notes" onChange={(e)=>setRejectDescription(e?.target?.value)}></textarea>
                    </div>
                </div>
                <div className="modal-footer modal-footer-border flex px-22">
                  <button className="btn btn-bold" id="cancelDelete" aria-label="Cancel" onClick={(e)=>handleCancel(e)}>{translate("project_listing.cancel")}</button>
                  <button id="reject-change-order" type="submit" className={rejectDescription!==""?"btn btn-bold active":"btn btn-bold active disabled-btn"}
                    onClick={confirmCancelSubmit}
                    aria-label="Save">{translate("change_order.cancel_submit")}</button>
                </div>
              
          </div>
          </div>
        </div>
      )}
      
    </div>
  );
}
